import { render, staticRenderFns } from "./SimpleMailIcon.vue?vue&type=template&id=4dc5b46a&scoped=true&"
import script from "./SimpleMailIcon.vue?vue&type=script&lang=js&"
export * from "./SimpleMailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc5b46a",
  null
  
)

export default component.exports